import { render, staticRenderFns } from "./areaTree.vue?vue&type=template&id=add5d3fe&scoped=true&"
import script from "./areaTree.vue?vue&type=script&lang=js&"
export * from "./areaTree.vue?vue&type=script&lang=js&"
import style0 from "./areaTree.vue?vue&type=style&index=0&id=add5d3fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add5d3fe",
  null
  
)

export default component.exports